import n from "./index30.js";
import { openBlock as r, createElementBlock as a, normalizeClass as s, createElementVNode as t, toDisplayString as i } from "vue";
import "./index31.js";
import p from "../../../../_virtual/index.js";
function f(o, e, m, u, k, b) {
  return r(), a("div", {
    class: s([
      "mobile-link-container ",
      o.isOnSelectionPage ? "mobile-selection-page" : ""
    ])
  }, [
    t("button", {
      target: "_blank",
      onClick: e[0] || (e[0] = (l) => o.aboutPage()),
      class: "footer-link-button"
    }, i(o.t("footer.about-us")), 1),
    t("button", {
      class: "dialog-link footer-link-button",
      onClick: e[1] || (e[1] = (l) => o.setShowPolicyDialog(!0, o.PolicyDialogType.PrivacyPolicy))
    }, i(o.t("footer.privacy-policy")), 1),
    t("button", {
      class: "dialog-link footer-link-button",
      onClick: e[2] || (e[2] = (l) => o.setShowPolicyDialog(!0, o.PolicyDialogType.Disclaimer))
    }, i(o.t("footer.disclaimer")), 1)
  ], 2);
}
const P = /* @__PURE__ */ p(n, [["render", f], ["__scopeId", "data-v-97eef633"]]);
export {
  P as default
};
//# sourceMappingURL=index28.js.map
